import { render, staticRenderFns } from "./SendProposal.vue?vue&type=template&id=4bdc1632&scoped=true"
import script from "./SendProposal.vue?vue&type=script&lang=js"
export * from "./SendProposal.vue?vue&type=script&lang=js"
import style0 from "./SendProposal.vue?vue&type=style&index=0&id=4bdc1632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc1632",
  null
  
)

export default component.exports